import {MODALITY} from '@domain/model/Account/Subscription/Subscription';

export const TEXT = {
  TITLE: {id: 'account_yourPlan.cancelPlan.title'},
  PLAN_DESCRIPTION_MONTHLY: {id: 'account_yourPlan.cancelPlan.subtitle1month'},
  PLAN_DESCRIPTION_BIMONTHLY: {id: 'account_yourPlan.cancelPlan.subtitle2month'},
  PLAN_DESCRIPTION_QUARTERLY: {id: 'account_yourPlan.cancelPlan.subtitle3month'},
  MODALITY_BIMONTHLY_TITLE: {id: 'account_currentLK.subscribing.2month'},
  MODALITY_QUARTERLY_TITLE: {id: 'account_currentLK.subscribing.3month'},
  MOST_POPULAR: {id: 'account_currentLK.subscribing.catchPhrase'},
  CTA_UPDATE_PLAN: {id: 'account_yourPlan.cancelPlan.updateCta'},
  CTA_CANCEL_PLAN: {id: 'account_yourPlan.cancelPlan.cancelCta'},
  CTA_CLOSE: {id: 'account_yourPlan.cancelPlan.continueCta'},
} as const;

export const TEXT_DESCRIPTION = {
  [MODALITY.ON_DEMAND]: TEXT.PLAN_DESCRIPTION_QUARTERLY,
  [MODALITY.MONTHLY]: TEXT.PLAN_DESCRIPTION_MONTHLY,
  [MODALITY.BIMONTHLY]: TEXT.PLAN_DESCRIPTION_BIMONTHLY,
  [MODALITY.QUARTERLY]: TEXT.PLAN_DESCRIPTION_QUARTERLY,
} as const;
